import styled from '@emotion/styled';
import PolarisIcon from '../PolarisIcon';
import { Tooltip, IconButton } from '@mui/material';

const EditActionButtons = ({ onSave, onCancel }) => {
  return (
    <EditActionButtonsWrapper>
      <Tooltip title="Cancel" placement="top" arrow>
        <StyledCancelPolarisIconButton onClick={onCancel}>
          <PolarisIcon icon="close" height={20} width={20} />
        </StyledCancelPolarisIconButton>
      </Tooltip>
      <Tooltip title="Save Changes" placement="top" arrow>
        <IconButton color="primary" onClick={onSave}>
          <PolarisIcon icon="check" height={20} />
        </IconButton>
      </Tooltip>
    </EditActionButtonsWrapper>
  );
};

export default EditActionButtons;

const EditActionButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const StyledCancelPolarisIconButton = styled(IconButton)`
  opacity: 0.6;
`;
